(() => {
  const stateKey = '__ibExpandedProductSpecsV51';
  if (window[stateKey]) return;

  const state = { contexts: new Map() };
  window[stateKey] = state;

  const extraKeys = [
    'material', 'color_finish', 'weight', 'capacity', 'flow_rate',
    'daily_production', 'power', 'voltage_frequency', 'refrigerant',
    'noise_level', 'ip_rating', 'consumption', 'tank_count', 'tap_count', 'gas_mix',
  ];

  const normalizeId = (value) => String(value ?? '').split('/').pop();

  const keepOpen = (details) => {
    details.open = true;
    if (details.dataset.ibAlwaysOpenBound === 'true') return;
    details.dataset.ibAlwaysOpenBound = 'true';
    details.addEventListener('toggle', () => {
      if (!details.open) details.open = true;
    });
  };

  const makeDetails = (support, data) => {
    const inner = support.querySelector('.ib-product-data__inner, .ib-product-support__inner');
    if (!inner) return null;

    let accordions = inner.querySelector('.ib-product-data__accordions');
    if (!accordions) {
      accordions = document.createElement('div');
      accordions.className = 'ib-product-data__accordions';
      const help = inner.querySelector('.ib-product-data__help');
      if (help) help.insertAdjacentElement('beforebegin', accordions);
      else inner.appendChild(accordions);
    }

    const details = document.createElement('details');
    details.dataset.ibTechSpecs = '';
    details.dataset.ibTechSpecsV51 = '';

    const summary = document.createElement('summary');
    summary.textContent = data.specsTitle || 'Especificaciones técnicas';

    const content = document.createElement('div');
    content.className = 'ib-product-data__content';

    const empty = document.createElement('p');
    empty.className = 'ib-product-data__specs-empty';
    empty.dataset.ibSpecsEmpty = '';
    empty.textContent = data.specsEmpty || '';

    const list = document.createElement('dl');
    list.className = 'ib-product-data__specs';
    list.dataset.ibSpecsList = '';

    content.append(empty, list);
    details.append(summary, content);
    accordions.prepend(details);
    keepOpen(details);
    return details;
  };

  const findSupport = (productId) => {
    const specific = document.querySelector(`main [data-ib-product-specs-root][data-ib-product-id="${productId}"]`);
    if (specific) return specific;
    return document.querySelector('main section.ib-product-support');
  };

  const ensureRow = (list, key, label) => {
    let row = list.querySelector(`[data-ib-extra-spec-row="${key}"]`);
    if (row) return row;

    row = document.createElement('div');
    row.dataset.ibExtraSpecRow = key;
    row.hidden = true;

    const term = document.createElement('dt');
    term.textContent = label || key;

    const value = document.createElement('dd');
    value.dataset.ibExtraSpecValue = key;

    row.append(term, value);
    list.appendChild(row);
    return row;
  };

  const render = (context, variantId) => {
    const { data, details, list, empty } = context;
    const variantSpecs = data.variants?.[normalizeId(variantId)] || null;
    let extraHasAny = false;

    for (const key of extraKeys) {
      const row = ensureRow(list, key, data.labels?.[key]);
      const valueNode = row.querySelector(`[data-ib-extra-spec-value="${key}"]`);
      const value = (variantSpecs?.[key] || data.product?.[key] || '').toString().trim();
      row.hidden = !value;
      if (valueNode) valueNode.textContent = value;
      if (value) extraHasAny = true;
    }

    const originalHasAny = [...list.querySelectorAll('[data-ib-spec-row]')].some((row) => !row.hidden);
    const hasAny = originalHasAny || extraHasAny;

    list.hidden = !hasAny;
    if (empty) empty.hidden = hasAny;
    keepOpen(details);
  };

  const initDataNode = (dataNode) => {
    if (!(dataNode instanceof HTMLScriptElement) || dataNode.dataset.ibExpandedInitialized === 'true') return;

    let data;
    try {
      data = JSON.parse(dataNode.textContent || '{}');
    } catch (error) {
      console.error('[Install Beer] Invalid expanded specifications data', error);
      return;
    }

    const productId = normalizeId(data.productId);
    if (!productId) return;

    const support = findSupport(productId);
    if (!support) return;

    let details = support.querySelector('details[data-ib-tech-specs]');
    if (!details && data.hasExtraSpecs) details = makeDetails(support, data);
    if (!details) return;

    details.dataset.ibTechSpecsV51 = '';
    keepOpen(details);

    const list = details.querySelector('[data-ib-specs-list]');
    const empty = details.querySelector('[data-ib-specs-empty]');
    if (!list) return;

    const context = { data, details, list, empty };
    state.contexts.set(productId, context);
    render(context, data.initialVariantId);

    list.setAttribute('aria-live', 'polite');
    list.setAttribute('aria-atomic', 'false');
    dataNode.dataset.ibExpandedInitialized = 'true';
  };

  const initAll = (root = document) => {
    const nodes = root instanceof Element && root.matches('[data-ib-expanded-specs-data]')
      ? [root]
      : root.querySelectorAll?.('[data-ib-expanded-specs-data]') || [];
    nodes.forEach(initDataNode);
  };

  document.addEventListener('shopify:product:select', (event) => {
    const productId = normalizeId(event.product?.id);
    const context = state.contexts.get(productId);
    if (!context) return;

    Promise.resolve(event.promise)
      .then((result) => {
        const variantId = result?.variant?.id || event.detail?.variantId || '';
        queueMicrotask(() => render(context, variantId));
      })
      .catch(() => queueMicrotask(() => render(context, '')));
  });

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }
})();
